<template>
	<div class="page-container">
		 <div class="content">
	   		 <div class="content-main-1">
			         <div class="box-left">
			                <div class="box-map">
	   			                  <h1 class="text-name">NOSTRA A.I 아바타의<br>
				                  					  {{info.testName}} 성적
				                  </h1>
				                  <div style='width:400px;margin:43px auto 10px auto;height:200px;'>
										<canvas id="radarChart" style="width:100%;height:200px;"></canvas>
								  </div>
				                  <ul class="box-list">
				                  	    <li><span class="radius-red"></span>전국아바타 평균</li>
				                  	    <li><span class="radius-red" style=" background:#3D79FF"></span>내 아바타</li>
				                  </ul>
				            </div>
				            <div class="box-menu">
				            	  <ul>
				            	     <li>회득점수</li>
				            	  	 <li>순위</li>
				            	  	 <li>상위수준</li>
				            	  </ul>
				            	  <ul class="box-two"style="color:#3D79FF;" >
				            	     <li>{{info.score}}<span class="text-a"></span></li>
				            	  	 <li>{{info.rank}}</li>
				            	  	 <li>{{info.rankPer}}%</li>
				            	  </ul>
				            	  <ul class="box-free">
				            	     <li>/{{info.allScore}}점</li>
				            	  	 <li>/{{info.allUser}}명</li>
				            	  	 <li>/100%</li>
				            	  </ul>
				            </div>
				            <div class="box-menu" >
				            	  <ul>
				            	       <li>정답문항수</li>
				            	  	 <li>푼 문항수</li>
				            	  	 <li>정답률(푼 문항)</li>
				            	  </ul>
				            	  <ul class="box-two"style="color:#3D79FF;" >
				            	       <li>{{info.gtotal}}</li>
				            	  	   <li>{{info.allTotal}}</li>
				            	  	   <li>{{info.gtotalPer}}%</li>
				            	  </ul>
				            	  <ul class="box-free">
				            	     <li>/{{info.allTotal}}문항</li>
				            	  	 <li>/{{info.allTotal}}문항</li>
				            	  	 <li>/{{info.allTotal}}문항</li>
				            	  </ul>
				            </div>
                    </div>
					<div class="box-right">
					      <div class="box-card">
						       성적평
							   <ul class="box-list-card">
							   		<li>내 아바타는 전국 평균에 비해</li>
									
									<li v-for="data in eval_category"><span class="text">{<span>{{data.name}}</span>}</span>에서 {{data.report}}</li>
							   </ul>
						  </div>
						  <div class="box-card" style='background:none;'>
						       <!-- 평가힝목 및 통계
							   <ul class="box-list-card">
							   		<li class="text-list">기획 필요</li>
							   </ul -->
						  </div>
				   </div>
			 </div>  
	   </div>
	</div>
</template>

<script>
export default {
	name: 'userReport',
	props:["no"],
	data() {

		  return {
			  	info:{},
				eval_category:{},
				labels: [],
				dataset: []
		  }
	},
	created() {
		this.getData();
		
	},
    methods: {
	  getData() {
		  	var obj = this;
			this.$form.sendPost({no:this.no,cmd:'ai'},'problem/getTestResult',function(resp) {
				if(resp.result!='succ') {
					var params = {};
					params.content = '문제를 모두 풀어야 성적을 확인할수 있습니다';
					params.doAction = function() {
						obj.$emit('eventBack');
					}
					obj.$eventBus.$emit('dialogOpen',params);
					return;
				} else {
					obj.info = resp.info;
					obj.eval_category = resp.eval_category;
					obj.getGraph(obj.eval_category,resp.maxCategoryTotal);
				
				}
			});
	  
	  },
	  getGraph(category,max) {
		if(category.length<1)return;
		var labels = [];
		var allData = [];
		var userData = [];

		for(var k in category) {
			var item = category[k];
			labels.push(item.name);
			userData.push(item.user);
			allData.push(item.total);
		}

		Chart.defaults.global.defaultFontColor = "#000";
		Chart.defaults.global.pointLabelFontSize = 20;
		Chart.defaults.global.defaultFontSize = 13;

		var radarData = {
			labels: labels,
			datasets: [{
				label: false,
				data: allData,
				backgroundColor: "rgba(254,59,0,0.4)",
				pointBackgroundColor:'#FE3B00',
				pointRadius:4,
				borderColor: "#FE3B00",
				borderWidth: 1,
				pointLabelFontSize: 20,
			},
			{
				label: false,
				data: userData,
				backgroundColor: "rgba(61,121,255,0.4)",
				pointBackgroundColor:'#3D79FF',
				pointRadius:4,
				borderColor: "#3D79FF",
				borderWidth: 1,
				pointLabelFontSize: 1,
			}]
		};

		var radarOptions = {
		  elements: {
		    point: {
		      radius: 2
		    }
		  },
		  responsive: false,
		  maintainAspectRatio: false,
		  scale: {
		    pointLabels: {
		      fontSize: 13,
		      color: "#444"
		    },
		    angleLines: {
		      display: true,
		      color: "#555"
		    },
		    gridLines: {
		      color: "#555",
		      tickMarkLength: 3
		    },
		    ticks: {
		      label: false,
		      min: 0,
		      max: max,
		      fixedStepSize: parseInt(max/5),
		      showLabelBackdrop: false,
		      fontSize: 0,
		      color: "#eee",
		    }
		  },
		  title: {
		    display: false
		  },
		  legend: {
		    display: false,
		  }
		};

		var ctx5 = document.getElementById("radarChart").getContext("2d");

		new Chart(ctx5, {
		  type: 'radar',
		  data: radarData,
		  options: radarOptions
		});
	}

	  
	  
  },
  mounted() {
	
  },
  updated() {
	
  }

}
</script>

<style lang="scss" scoped>
.page-container {
	width:calc(100vw);
	min-height:calc(100vh);
	background:#E6E8F4;
	.content   {
		width:100%;
		padding:180px 0 55px; 
		font-family: 'Nanum Gothic', sans-serif;
		background:#E6E8F4;
		overflow:auto;
		.content-main-1 {
			  					width:800px;
								height:auto;
								margin:0 auto;
							
								.box-left        {
									      float:left;
										  width:500px;
										  background:#fff;
										  padding-top:40px;
										  .box-map          {
										  		     text-align:center;
													 width:458px;
													 margin:0 auto;
													 border-bottom:1px solid #E6E6E6;
													 padding-bottom:15px;
													 .text-name         {
													            font-size:18px;
																line-height:23px;
																color:#4E4E4E;
													 }
													 img                {
													 			padding:40px 0;
													 }
													 .box-list			{
													 			display:flex;
																width:210px;
																margin:0 auto;
																li             {
																		font-size:11px;
																		color:#000;
																		margin-left:20px;
																		.radius-red       {
																					 display:inline-block;
																					 width:9px;
																					 height:9px;
																					 border-radius:50%;
																					 background:#FD3A00;
																					 margin-right:5px;
																		}
																}
													 }
										  }
										  .box-menu          {
										  			  width:512px;
													  margin:15px 0;
													  ul             {
													  		  margin-top:2px;
															  display:flex;
															  li            {
															  		 width:33%;
																	 text-align:center;
																	 font-size:11px;
															  }
													  }
													  ul.box-two          {
													  			li          {
																	  font-size:20px;
																	  .text-a         {
																	  		   font-size:14px;
																	  }
																}
													  }
													  ul.box-free          {
													  			 li            {
																 		color:#A6A6A6;
																		font-size:12px;
																 }
													  }
										  }
								}
								.box-right        {
										  float:right;
										  width:280px;
										
										  .box-card         {
										  	        width:305px;
													padding:25px 0 15px;
													background:#fff;
													text-align:center;
													font-size:16px;
													color:#333333;
													&:last-child        {
															    margin-top:10px;
													}
													.box-list-card       {
																   width:240px;
																   margin:10px auto;
																   height:190px;
																   background:#F4F4F4;
																   padding:50px 30px;
																   li                 {
																   			  font-size:12px;
																			  font-weight:bold;
																			  color:#2C2C2C;
																			  .text          {
																			  			color:#3D79FF;
																			  }
																   }
																   .text-list       {
																   			 margin-top:30px;
																   }
														
													}
										  }
									}
		}
	}
			
	.screenLayout {
		.content-wrapper {
			.content-box {
				border-radius:0;
				width:400px;
				margin:80px auto;
				padding:0;
				.search-box {
					padding:15px 20px 0 20px;
					display:flex;
					li:first-child {
						width:300px;
						input {
							width:100%;
							height:40px;
							padding:0 10px;
							border:solid 1px #dfdfdf;
						}
					}
					li:last-child {
						width:100px;
						.md-button {
							width:100%;
							margin:0;
							height:40px;
							background:#448AFF;
							color:#fff;
						}
					}
				}
				.data-box {
					padding:20px 20px 50px 20px;
					height:450px;
					overflow-y:auto;
					text-align:left;
					li.data-item {
						text-align:left;
						.goodAnswername {
							padding:5px 0 8px 0;
							font-size:11pt;
							font-weight:bold;
							color:#000;
							.uanswer {
								color:#F24A4A;
								display:inline-block;
							}
						}
						.box-content {
							font-size:9pt;
						}

					}
				}
				.hide-button { 
					background:#515F83;
					width:100%;
					height:45px;
					line-height:45px;
					color:#fff;
					text-align:center;
					border:none;
					cursor:pointer;
				}
			}
		}
	}
}
</style>